<template>
  <div id="speciesSet">
    <b-container v-if="authenticated">
      <h2>Create your species selection</h2>
      <h4>Select several organisms and create a new set</h4>
      <b-form @submit="createSet">
        <b-row>
          <b-col cols="12" sm="6" md="3">
            <b-form-input
              id="setName"
              v-model="input.setName"
              placeholder="Name of your new set"
              :state="nameState"
              required
            />
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <b-button type="submit" variant="primary">Create</b-button>
          </b-col>
        </b-row>

        <b-alert
          dismissible
          :show="dismissCountDown"
          :variant="variant"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
          >{{ messageAlert }}</b-alert
        >

        <Tree ref="tree" multiple :data="tree_data" show-checkbox allow-batch />
      </b-form>
    </b-container>
  </div>
</template>

<script>
import Tree from '@/components/Tree.vue';
import Vue from 'vue';

export default {
  components: {
    Tree,
  },
  data() {
    return {
      input: { setName: null, selected: [] },
      dismissSecs: 3,
      dismissCountDown: 0,
      messageAlert: '',
      variant: 'success',
    };
  },
  computed: {
    nameState: function() {
      if (this.input.setName == null) {
        return false;
      }
      let x = this.input.setName.trim();
      return x.length > 0;
    },
    tree_data: function() {
      return this.$store.getters.getTreeData;
    },
    authenticated: function() {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    createSet(evt) {
      evt.preventDefault();

      let a_selected = this.$refs.tree.getSelected();

      if (a_selected.length == 0) {
        this.variant = 'danger';
        this.messageAlert = 'Select at least one node';
        this.showAlert();
      } else {
        let form = {};
        form.name = this.input.setName.trim();
        form.selected = a_selected.map(s => {
          return s.id;
        });

        form.login = this.$store.getters.getLogin;
        form.token = this.$store.getters.getToken;

        let loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
          loader: 'dots',
        });

        Vue.http.post('api/createSet', form).then(
          resp => {
            loader.hide();

            if (resp.body == null) {
              this.variant = 'danger';
              this.messageAlert = 'Server error';
              this.showAlert();
            } else {
              if (resp.body.success == true) {
                this.$store.dispatch('getSelections', { login: form.login }).then(
                  respSelections => {
                    if (respSelections.body != null && respSelections.body.success === true) {
                      this.variant = 'success';
                      this.messageAlert = 'Sets have been updated';
                      this.showAlert();
                    } else {
                      this.variant = 'danger';
                      this.messageAlert = respSelections.body.message;
                      this.showAlert();
                    }
                  },
                  () => {
                    this.variant = 'danger';
                    this.messageAlert = 'Server error when reloading data';
                    this.showAlert();
                  }
                );
              } else {
                this.variant = 'danger';
                this.messageAlert = resp.body.message;
                this.showAlert();
              }
            }
          },
          error => {
            loader.hide();

            this.variant = 'danger';
            this.messageAlert = 'Server error (' + error.statusText + ')';
            this.showAlert();
          }
        );
      }
    },
  },
};
</script>

<style scoped>
input {
  width: 200px;
  margin: 5px;
}

#speciesSet {
  margin: 25px;
}

.btn {
  float: left;
  margin: 5px;
}
</style>
